module.exports = __webpack_public_path__ + "static/media/img-03@2x.3b447346.png";